import { render } from "./BonnetsEtTurbans.vue?vue&type=template&id=3fe6e33f&scoped=true"
import script from "./BonnetsEtTurbans.vue?vue&type=script&lang=js"
export * from "./BonnetsEtTurbans.vue?vue&type=script&lang=js"

import "./BonnetsEtTurbans.vue?vue&type=style&index=0&id=3fe6e33f&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3fe6e33f"]])

export default __exports__